import React from 'react';
import { useAuth, useUser } from '@clerk/clerk-react';
import axiosInstance from '../config/axios';

const DebugClerkPage: React.FC = () => {
  const { isLoaded, isSignedIn, userId, sessionId, getToken } = useAuth();
  const { user } = useUser();

  const [token, setToken] = React.useState<string | null>(null);
  const [backendUser, setBackendUser] = React.useState<any>(null);
  const [backendError, setBackendError] = React.useState<string | null>(null);

  React.useEffect(() => {
    const fetchToken = async () => {
      if (isSignedIn) {
        const t = await getToken();
        setToken(t);
      }
    };
    fetchToken();
  }, [isSignedIn, getToken]);

  React.useEffect(() => {
    const fetchBackendUser = async () => {
      if (isSignedIn) {
        try {
          const response = await axiosInstance.get('/api/users/me');
          setBackendUser(response.data);
          setBackendError(null);
        } catch (error: any) {
          setBackendError(error.response?.data?.detail || error.message);
          setBackendUser(null);
        }
      }
    };
    fetchBackendUser();
  }, [isSignedIn]);

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>Clerk Debug Information</h1>
      
      <div style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
        <h2>Auth Status</h2>
        <p><strong>Is Loaded:</strong> {isLoaded ? '✅ Yes' : '❌ No'}</p>
        <p><strong>Is Signed In:</strong> {isSignedIn ? '✅ Yes' : '❌ No'}</p>
        <p><strong>User ID:</strong> {userId || 'N/A'}</p>
        <p><strong>Session ID:</strong> {sessionId || 'N/A'}</p>
      </div>

      {user && (
        <div style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
          <h2>User Information</h2>
          <p><strong>Email:</strong> {user.primaryEmailAddress?.emailAddress || 'N/A'}</p>
          <p><strong>Name:</strong> {user.fullName || 'N/A'}</p>
          <p><strong>First Name:</strong> {user.firstName || 'N/A'}</p>
          <p><strong>Last Name:</strong> {user.lastName || 'N/A'}</p>
          <p><strong>Created At:</strong> {user.createdAt ? new Date(user.createdAt).toLocaleString() : 'N/A'}</p>
        </div>
      )}

      <div style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
        <h2>Environment</h2>
        <p><strong>Publishable Key:</strong> {process.env.REACT_APP_CLERK_PUBLISHABLE_KEY?.substring(0, 20)}...</p>
        <p><strong>API URL:</strong> {process.env.REACT_APP_API_URL || '/'}</p>
      </div>

      {token && (
        <div style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
          <h2>Token (First 100 chars)</h2>
          <p style={{ wordBreak: 'break-all', fontSize: '12px' }}>{token.substring(0, 100)}...</p>
        </div>
      )}

      <div style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
        <h2>Backend User Data</h2>
        {backendError ? (
          <p style={{ color: '#dc3545' }}><strong>Error:</strong> {backendError}</p>
        ) : backendUser ? (
          <>
            <p><strong>Email:</strong> {backendUser.email}</p>
            <p><strong>Name:</strong> {backendUser.name || 'N/A'}</p>
            <p><strong>Clerk ID:</strong> {backendUser.clerk_id}</p>
            <p><strong>Is Admin:</strong> {backendUser.is_admin ? '✅ YES' : '❌ NO'}</p>
            <p><strong>Created At:</strong> {new Date(backendUser.created_at).toLocaleString()}</p>
          </>
        ) : (
          <p>Loading backend user data...</p>
        )}
      </div>
    </div>
  );
};

export default DebugClerkPage;
